import React, { memo } from 'react';
import {
  Box,
  Paper,
  Typography,
  Avatar,
  Chip,
} from '@mui/material';
import {
  SmartToy as BotIcon,
} from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';

interface ChatHeaderProps {
  isConnected: boolean;
}

export const ChatHeader = memo<ChatHeaderProps>(({ isConnected }) => {
  const theme = useTheme();

  return (
    <Paper
      elevation={2}
      sx={{
        p: 2,
        mb: 2,
        backgroundColor: theme.palette.primary.main,
        color: 'white',
        borderRadius: 2,
      }}
    >
      <Box display="flex" alignItems="center" gap={2}>
        <Avatar sx={{ backgroundColor: 'white', color: theme.palette.primary.main }}>
          <BotIcon />
        </Avatar>
        <Box>
          <Typography variant="h6" fontWeight="bold">
            LedgerX365 Assistant
          </Typography>
          <Box display="flex" alignItems="center" gap={1}>
            <Chip
              label={isConnected ? 'Online' : 'Offline'}
              size="small"
              color={isConnected ? 'success' : 'error'}
              sx={{ color: 'white' }}
            />
            <Typography variant="caption">
              Your AI-powered accounting assistant
            </Typography>
          </Box>
        </Box>
      </Box>
    </Paper>
  );
});

ChatHeader.displayName = 'ChatHeader';

